<template>
  <div class="mb-4 card-list">
    <div
      @click="$emit('openEventDialog', eventItem)"
      :class="index > 0 ? 'mt-5' : 'mt-0'"
      v-for="(eventItem, index) in items"
      :key="'items_' + index"
    >
      <v-card flat>
        <div class="d-flex flex-start">
          <div
            style="width:30%"
            class="subtitle-1 grow ma-2 mr-0"
          >
            <div
              class="d-inline-flex flex-column"
              v-if="!eventItem.allDay && eventItem.startText === null"
            >
              <div
                class="text-right"
                v-text="
                  new Date(eventItem.startDateTime).toLocaleTimeString(
                    getLocale(),
                    {
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric'
                    }
                  )
                "
              />
              <div
                class="text-right"
                v-text="
                  new Date(eventItem.endDateTime).toLocaleTimeString(
                    getLocale,
                    {
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric'
                    }
                  )
                "
              />
            </div>
            <div v-if="eventItem.allDay">
              {{ $t("calendar.allDay") }}
            </div>
            <div v-if="eventItem.startText != null">
              {{ eventItem.startText }}
            </div>
          </div>
          <div
            :style="
              `border-color: ${getSchoolColour(
                eventItem.domain
              )}; background-color: ${getSchoolColour(eventItem.domain)}`
            "
            class="card--line ma-2 mr-0"
          >
            &nbsp;
          </div>
          <div
            class="d-flex flex-column"
            style="flex-grow: 1; width: 70%"
          >
            <v-card-title
              :class="
                `pa-3 pt-2 pb-1 card--title ${
                  $store.getters['readEvents'].find(a => a === eventItem.id)
                    ? 'read'
                    : null
                }`
              "
            >
              {{ eventItem.title }}
            </v-card-title>
            <v-card-text class="pa-3 pt-0 pb-1 card--name">
              {{ getName(eventItem.domain) }}
            </v-card-text>
            <v-card-text class="pa-3 pt-0 card--description">
              {{ eventItem.location }}
            </v-card-text>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import { AppIcon } from "@nswdoe/doe-ui-core";
import { getLocale } from "@/mixins/locale";

const EventList = {
  name: "eventList",
  components: {
    AppIcon
  },
  methods: {
    getLocale,
    getLogo(schoolId) {
      if (schoolId != "global") {
        return this.schoolImages.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )
          ? this.schoolImages.find(
              schoolInfo => schoolInfo.schoolId == schoolId
            ).logo
          : null;
      }
      return "nsw_logo.svg";
    },
    getName(schoolId) {
      if (schoolId != "global") {
        return this.schoolImages.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )
          ? this.schoolImages.find(
              schoolInfo => schoolInfo.schoolId == schoolId
            ).name
          : null;
      }
      return "NSW Department of Education";
    },
    getSchoolColour(schoolId) {
      if (schoolId != "global") {
        return this.schoolImages.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )?.colour;
      }
      return "#264189";
    },
    getDescription(description) {
      return `${description.substr(0, 100)} ${
        description.substr(0, 100).length < 100 && description ? "" : "..."
      }`;
    }
  },
  props: {
    items: {
      type: Array,
      default: function() {
        return [];
      }
    },
    schoolImages: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};

export default EventList;
</script>
<style lang="scss">
.v-card__title.card--title {
  word-break: break-word;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}
.v-card__text {
  &.card--description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #4c4f55;
    word-break: break-word;
  }
  &.card--name {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #000 !important;
    word-break: break-word;
  }
}
.card--description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #4c4f55;
  word-break: break-word;
}
.card--line {
  border: 1px solid #1d428a;
  max-width: 3px;
  border-radius: 3px;
  background-color: #1d428a;
}

.image--content {
  width: 150px;
  max-width: 150px;
}
.card-list {
  .v-sheet.v-card {
    border: 1px solid #c8dcf0 !important;
    border-radius: 7px !important;
  }
  .v-card .v-card {
    border: none !important;
    border-radius: 0 !important;
  }
}
.image--border {
  border: 1px solid #fff !important;
  border-radius: 5px;
}
.read {
  color: rgba(0, 0, 0, 0.6);
}
</style>
